import { isObject } from '@aviata/type-guards';
import { get, isString, uniq } from 'lodash-es';
import { parseJwt } from '../../../entities/user-store/lib/parse-jwt';
import type { AppName } from '../types';

// TODO: encapsulate all native events in this module (PaymentSuccess, PaymentError, AuthError)
class AuthSuccessEvent extends CustomEvent<{ otpToken: string }> {
  static readonly eventName = 'freedomnative#authsuccess';

  constructor(otpToken: string) {
    super(AuthSuccessEvent.eventName, { detail: { otpToken } });
  }
}

declare global {
  interface WindowEventMap {
    [AuthSuccessEvent.eventName]: AuthSuccessEvent;
  }
}

export function registerAuthSuccessEventEmitter() {
  window.FreedomWebApp.onAuthSuccess = (otpToken: string) => {
    window.dispatchEvent(new AuthSuccessEvent(otpToken));
  };
}

export function addAuthSuccessEventListener(
  appName: AppName,
  cb: (otpToken: string) => void,
) {
  function eventHandler(event: AuthSuccessEvent) {
    const { otpToken } = event.detail;
    const parsedToken = parseJwt(otpToken);
    if (!isObject(parsedToken)) {
      return;
    }

    const nativeConsumerName = get(parsedToken, 'consumer.name');
    if (!isString(nativeConsumerName)) {
      return;
    }

    const isRWFlow = appName === 'railways';
    const isRWNativeAuth = nativeConsumerName.includes('railways');

    // To match the native incoming auth event to app that made initial auth request
    // e.g. freedom-cabinet makes to parallel auth requests from avia/rw apps
    if (uniq([isRWFlow, isRWNativeAuth]).length === 1) {
      cb(otpToken);
      window.removeEventListener(AuthSuccessEvent.eventName, eventHandler);
    }
  }

  window.addEventListener(AuthSuccessEvent.eventName, eventHandler);
}
